var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-header"},[_c('img',{attrs:{"src":require("@/assets/back-black.png")},on:{"click":_vm.goBack}}),_vm._v(" 欢迎来到九方智投股圈 ")])}
var staticRenderFns = []

export { render, staticRenderFns }